/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue';
import Router from 'vue-router';
import firebase from 'firebase/app';
import 'firebase/auth';
import {db} from '@/firebaseConfig';
import store from './store/store';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return {x: 0, y: 0}
  },
  routes: [
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/',
          name: 'home',
          component: () => import('./views/ECommerceShop')
        },
        {
          path: '/access',
          name: 'access',
          component: () => import('./views/pages/Access'),
          meta: {authRequired: false}
        },
        {
          path: '/profile',
          name: 'profile',
          component: () => import('./views/ECommerceShop'),
          meta: {authRequired: true}
        },
        {
          path: '/shop',
          name: 'shop',
          props: true,
          component: () => import('./views/ECommerceShop'),
          meta: {authRequired: false}
        },
        {
          path: '/category/:category',
          name: 'category-view',
          component: () => import('./views/ECommerceShop'),
          meta: {
            authRequired: false,
            breadcrumb: [
              {title: 'Inicio', url: '/'},
              {title: 'Productos', active: true}
            ],
            parent: 'ecommerce-item-detail-view',
            pageTitle: 'Productos'
          }
        },
        {
          path: '/item/:item',
          name: 'item-detail-view',
          component: () => import('./views/ECommerceShop'),
          meta: {
            authRequired: false,
            breadcrumb: [
              {title: 'Inicio', url: '/'},
              {title: 'Detalles del producto', active: true}
            ],
            parent: 'ecommerce-item-detail-view',
            pageTitle: 'Detalles del producto'
          }
        },
        {
          path: '/checkout',
          name: 'checkout',
          component: () => import('./views/ECommerceShop'),
          meta: {
            authRequired: false,
            breadcrumb: [
              {title: 'Inicio', url: '/'},
              {title: 'Pedido', active: true}
            ],
            pageTitle: 'Pedido'
          }
        },
        {
          path: '/shipping',
          name: 'shipping',
          component: () => import('./views/ECommerceShop'),
          meta: {
            authRequired: true,
            breadcrumb: [
              {title: 'Inicio', url: '/'},
              {title: 'Políticas de envío', active: true}
            ],
            pageTitle: 'Políticas de envío'
          }
        },
        {
          path: '/learn',
          name: 'learn',
          component: () => import('./views/ECommerceShop'),
          meta: {
            authRequired: false,
            breadcrumb: [
              {title: 'Inicio', url: '/'},
              {title: 'Aprende', active: true}
            ],
            pageTitle: 'Aprende a comprar en Biblias.gt'
          }
        },
        {
          path: '/donate',
          name: 'donate',
          component: () => import('./views/ECommerceShop'),
          meta: {
            authRequired: false,
            breadcrumb: [
              {title: 'Inicio', url: '/'},
              {title: 'Donaciones', active: true}
            ],
            pageTitle: 'Donaciones'
          }
        },
        {
          path: '/login',
          name: 'page-login',
          component: () => import('@/views/pages/Login.vue'),
          meta: {authRequired: false}
        },
        {
          path: '/pages/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue'),
          meta: {authRequired: false}
        },
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/pages/error-404'
    }
  ],
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

router.beforeEach((to, from, next) => {
  firebase.auth().onAuthStateChanged(() => {
    const firebaseCurrentUser = firebase.auth().currentUser;
    if (firebaseCurrentUser && to.name == 'login') {
      router.push({path: '/'});
    } else {
      if (firebaseCurrentUser) {
        if (store.state.AppActiveUser.loggingIn) {
          const self = this;
          db.collection('users').doc(firebaseCurrentUser.email).get()
            .then(snapshot => {
              store.commit('UPDATE_USER_INFO', {
                uid: firebaseCurrentUser.uid,
                displayName: firebaseCurrentUser.displayName,
                email: firebaseCurrentUser.email,
                phone: firebaseCurrentUser.phoneNumber,
                photoURL: firebaseCurrentUser.photoURL,
                loggingIn: false
              }, {root: true});
              if (snapshot.exists) {
                const userData = snapshot.data();
                if (userData) {
                  store.commit('UPDATE_USER_INFO', userData, {root: true});
                } else {
                  router.push({path: '/profile'});
                }
                router.push({path: to.path});
              } else {
                router.push({path: '/profile'});
              }
            })
            .catch((err) => {
              self.$vs.notify({
                time: 2500,
                title: 'Error al registrar usuario, por favor intente de nuevo',
                text: err.message,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
              });
            });
        } else {
          return next();
        }
      } else {
        return next()
      }
    }

    // If auth required, check login. If login fails redirect to login page
/*
    if (to.meta.authRequired) {
      if (!firebaseCurrentUser) {
        // router.push({path: '/login', query: {to: to.path}})
        router.push({path: '/login'})
      }
    }
*/

    // return next()
    // Specify the current path as the customState parameter, meaning it
    // will be returned to the application after auth
    // auth.login({ target: to.path });
  })

})

export default router
